import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";
import { useAuth } from "@/auth/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import LanguageSwitcher from "@/components/LanguageSwitcher";

const AdminLogin = () => {
  const { t } = useLanguage();
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (user && user.role === "admin") {
      navigate("/admin", { replace: true });
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("OK");
      navigate("/admin", { replace: true });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : t("common.error"));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen bg-[#FDFBF7] flex flex-col"
    >
      <div className="container-fhk flex items-center justify-between py-6 gap-6">
        <a href="/" className="font-display text-xl text-[#2D2824]">
          Fatma Hanım <span className="text-[#B5441E]">Konağı</span>
        </a>
        <div className="flex items-center ps-4">
          <LanguageSwitcher />
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center px-6">
        <form
          onSubmit={handleSubmit}
          data-testid="admin-login-form"
          className="w-full max-w-md bg-[#F4EFE6] border border-[#E2D9C8] p-10 rounded-sm space-y-6"
        >
          <h1 className="font-display text-3xl text-[#2D2824]">{t("admin.login_title")}</h1>
          <div className="space-y-2">
            <Label htmlFor="email" className="text-[#5C4D3C]">{t("admin.email")}</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="admin-email"
              className="bg-white border-[#E2D9C8]"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password" className="text-[#5C4D3C]">{t("admin.password")}</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="admin-password"
              className="bg-white border-[#E2D9C8]"
            />
          </div>
          <Button
            type="submit"
            disabled={submitting}
            data-testid="admin-login-submit"
            className="w-full bg-[#B5441E] hover:bg-[#9D3A19] text-white uppercase tracking-[0.2em] text-xs py-6 rounded-sm"
          >
            {submitting ? t("admin.signing") : t("admin.sign_in")}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
